import { appendParameters, removeParameters } from 'helpers/url'

export const generateUrl = ({
  page,
  pathname,
  params,
}: {
  page: number
  pathname: string
  params: {
    [key: string]: string
  }
}) => {
  const pathnameWithSearch = appendParameters(pathname, params)

  if (page > 1) {
    return appendParameters(pathnameWithSearch, { page })
  }

  return removeParameters(pathnameWithSearch, ['page'])
}
